const cdnCreators = 'https://cdn.gymaholic.co/pages/creators/'

export default function getImageUrlCreatorUtil (filename) {
  return `${cdnCreators}${filename}`
}
